import React from 'react'

import { iconIdMapping } from '@arcade/web/icons/react'
import { ListItem, ListUnordered, PaddingInset } from '@cash-design-system/react'
import { ListUnorderedSize } from '@cash-web/protos/squareup/cash/ui/arcade/elements/ListUnordered.pb'
import {
  FormBlockerElementListUnorderedElement,
  FormBlockerElementListUnorderedElementType,
} from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import logger from '@cash-web/shared/util-logger'
import { useTextTokenizer } from '@cash-web/shared-feature-use-text-tokenizer'

export function ListUnorderedElement({
  inset = true,
  ...props
}: FormBlockerElementListUnorderedElement & { inset?: boolean }): React.ReactElement | null {
  const textTokenizer = useTextTokenizer()
  const type = props.type === FormBlockerElementListUnorderedElementType.SUBTLE ? 'subtle' : 'standard'
  const size = props.size === ListUnorderedSize.LARGE ? 'large' : 'compact'

  const items: ListItem[] =
    props.items?.map(item => {
      const Icon = item.icon?.arcade_id ? iconIdMapping[item.icon.arcade_id]?.Icon : undefined
      const tokenizedBody = textTokenizer(item.body)
      return {
        Icon,
        label: item.label ?? '',
        body: tokenizedBody,
        value: item.value,
      }
    }) ?? []

  if (items.length === 0) {
    logger.warn(new Error('ListUnorderedElement received empty items array'))
    return null
  }

  const list = <ListUnordered type={type} size={size} items={items} />
  return inset ? <PaddingInset>{list}</PaddingInset> : list
}
